import { ThemeProvider } from "@emotion/react";
import { createTheme, CssBaseline } from "@mui/material";
import { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./components/auth/AuthContext/AuthContext";
import SignIn from "./components/auth/Login";
import UserForm from "./components/auth/users/components/UserForm";
import DataGridComponent from "./components/auth/users/components/Users";
import Navbar from "./components/common/NavigationBar";
import ShowQrCode from "./components/qrcode/ShowQrCode";
import ProjectList from "./components/views/shipments/ShipmentsList";
import darkThemeWithCssVars from "./components/views/visuals/nanesaDarkTheme";
import nanesaLightTheme from "./components/views/visuals/nanesaLightTheme";
import "./app.css";

const App: React.FC = () => {
  // --- DarkMode ---
  const [darkMode, setDarkMode] = useState(localStorage.getItem("themeMode") === "dark" ? true : false);

  const darkTheme = createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
    },
  });

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    const newMode = mode === "light" ? "dark" : "light";
    setMode(newMode);
    localStorage.setItem("themeMode", newMode);
  };

  const savedMode = localStorage.getItem("themeMode");
  const [mode, setMode] = useState<"light" | "dark">(savedMode === "dark" ? "dark" : "light");

  // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

  return (
    <ThemeProvider theme={darkMode ? darkThemeWithCssVars : nanesaLightTheme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <MainLayout toggleDarkMode={toggleDarkMode} darkMode={darkMode} />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

interface NavbarProps {
  toggleDarkMode: () => void;
  darkMode: boolean;
}

const MainLayout: React.FC<NavbarProps> = ({ toggleDarkMode, darkMode }) => {
  const { isAuthenticated, userRole } = useAuth();
  return (
    <>
      <Routes>
        <Route path="/login" element={<SignIn />} />
        <Route path="/check/qrCode" element={<ShowQrCode />} />
        <Route
          path="*"
          element={
            isAuthenticated ?
              <>
                <Navbar toggleDarkMode={toggleDarkMode} darkMode={darkMode} />
                <Routes>
                  <Route path="/" element={<Navigate to={isAuthenticated ? "/list" : "/login"} />} />
                  <Route path="/list" element={isAuthenticated ? <ProjectList /> : <Navigate to="/login" />} />
                  <Route
                    path="/users/new"
                    element={
                      isAuthenticated ?
                        <div>
                          <h1>Nuovo Utente</h1>
                          <UserForm twoColumns={false} />
                        </div>
                      : <Navigate to="/login" />
                    }
                  />
                  <Route path="/users/list" element={isAuthenticated ? <DataGridComponent /> : <Navigate to="/login" />} />
                </Routes>
              </>
            : <Navigate to={"/login"} />
          }
        />
      </Routes>
    </>
  );
};

export default App;
